export const existingStatuses = [
  'Compte créé',
  'A renseigner',
  'A télécharger',
  'A interviewer',
  'A finaliser',
  'Validé',
  'A conserver',
  'Déclinée',
];

export const existingLocations = [
  'Aubervilliers',
  'Paris 12ème',
  'Paris 14ème',
  'Paris 17ème',
  'Paris 18ème',
  '-------------',
  'A distance',
  '22 rue Gabriel Lamé, Paris 12ème',
  '181 avenue Daumesnil, Paris 12ème',
  'Présentiel ou distanciel',
];

export const existingModalities = [
  'Sur site',
  'A distance',
  'Sur site ou à distance',
  'Hybride (alternance sur site et à distance)'
]

export const existingClasses = [
  'CP',
  'CE1',
  'CE2',
  'CM1',
  'CM2',
  '6ème',
  '5ème',
  '4ème',
  '3ème',
  'Seconde',
  'Première',
  'Terminale',
  'L1',
  'L2',
  'L3',
];

export const existingSubjects = [
  { label: 'Allemand' },
  { label: 'Anglais' },
  { label: 'Chinois' },
  { label: 'Espagnol' },
  { label: 'Français' },
  { label: 'Histoire-Géographie' },
  { label: 'Histoire' },
  { label: 'Géographie' },
  { label: 'Informatique' },
  { label: 'Mathématiques' },
  { label: 'Philosophie' },
  { label: 'Physique-Chimie' },
  { label: 'Physique' },
  { label: 'Chimie' },
  { label: 'SES' },
  { label: 'SVT' },
];

export const existingRooms = ['Salle 1', 'Salle 2', 'Salle 3', 'Salle 4'];

export const existingDays = [
  { label: 'Lundi' },
  { label: 'Mardi' },
  { label: 'Mercredi' },
  { label: 'Jeudi' },
  { label: 'Vendredi' },
  { label: 'Samedi' },
  { label: 'Dimanche' },
];

export const existingTimes = [
  { label: '08:00' },
  { label: '09:00' },
  { label: '10:00' },
  { label: '11:00' },
  { label: '12:00' },
  { label: '13:00' },
  { label: '14:00' },
  { label: '15:00' },
  { label: '16:00' },
  { label: '17:00' },
  { label: '18:00' },
  { label: '19:00' },
  { label: '20:00' },
  { label: '21:00' },
  { label: '22:00' },
];

export const existingLevels = JSON.stringify([
  { label: 'CP' },
  { label: 'CE1' },
  { label: 'CE2' },
  { label: 'CM1' },
  { label: 'CM2' },
  { label: '6ème' },
  { label: '5ème' },
  { label: '4ème' },
  { label: '3ème' },
  { label: 'Seconde' },
  { label: 'Première' },
  { label: 'Terminale' },
  { label: 'L1' },
  { label: 'L2' },
  { label: 'L3' },
]);
